// Shared between server and client (UX plan D4b, 5 Nov 2026).
/** The default reason written when an account is provisioned. It says nothing about the event, so screens do not repeat it. */
export const GENERIC_MATCH_REASON = 'Başvuru cevaplarınıza göre eşleşti.';
export const isGenericReason = reason => !reason || reason.trim() === GENERIC_MATCH_REASON;
